export const QUERY_NAMES = {
  PRODUCT_FILTERS: 'productFilters',
}
